import {Grid, IconButton,Typography, Box} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import SmartAppHotbar from "./SmartAppHotbar";
import { AppStorage } from "e.sic-platform.webclient/src/services/app/AppStorage";

export interface ISmartApp {
  appStorage: AppStorage,
  actionBar?: any;
  children: any;
}

export default observer(function SmartApp(props: ISmartApp) {
  const { appStorage } = props;

  return (
    <>
      <SmartAppHotbar {...props}/>
      <Grid container xs={12} sx={{p: 2}}>
        <Grid container xs = {3}  sx={{display: {lg: "block", xs: "none"}}}>
        <Grid item xs={12} lg ={12} className="centered" >
            {appStorage.image && (
              <img
                src={appStorage.image}
                height={300}
                style={{ maxWidth: "100%", marginTop: 4 }}
              />
            )}
          </Grid>
        </Grid>
        <Grid container xs={12} lg={9} >
          <Grid item xs={12} lg={6}>
            <Typography variant="h4" sx={{ marginBottom: 2, textAlign: {  xs: "center", lg: "left"} }}>
              {translationService.translate(appStorage.titleKey)}
            </Typography>
          </Grid>
          <Grid item xs={12} lg={12} >
            <Grid item xs={12} lg={6} >
              <Typography
                variant="body1"
                color="GrayText"
                sx={{ marginBottom: 3, lineHeight: 3, textAlign: {  xs: "center" ,lg: "left"}}}
              >
                {translationService.translate(appStorage.descriptionkey)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Box
          display="flex"
          sx={{ mb: 2, cursor: "pointer" }}
          onClick={() => appStorage.toggleCollapsed()}
        >
          <IconButton>
            {appStorage.collapsed ? (
              <ExpandMoreIcon
                sx={{
                  transform: "rotate(-90deg)",
                  fontWeight: "bold",
                  fontSize: "2rem",
                }}
              />
            ) : (
              <ExpandLessIcon
                sx={{
                  transform: "rotate(-90deg)",
                  fontWeight: "bold",
                  fontSize: "2rem",
                }}
              />
            )}
          </IconButton>
        </Box>

        <Grid container rowSpacing={2} sx={{mt: 2}}>
          {props.children}
        </Grid>
      </Grid>
    </>
  );
});
